﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProfiles = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
const StateProfile_1 = require("./StateProfile");
const StateProfileCreateByPhone_1 = require("./StateProfileCreateByPhone");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateProfiles extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Profiles", true);
        this._callbackOnSelect = null;
        this.page.ctrls.blockSearch.show();
        this.page.ctrls.taSearch.el.placeholder = "Search profiles";
        this.page.ctrls.btnSearch.onclick = () => this.trySearch();
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateProfileCreateByPhone_1.StateProfileCreateByPhone);
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.UsersControl))
            this.page.ctrls.btnNew.hide();
    }
    static SelectUser() {
        return new Promise((resolve, reject) => {
            gs_1.StateGS.Run(StateProfiles, { callbackOnSelect: resolve });
        });
    }
    start(arg) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (arg) {
                this._callbackOnSelect = arg.callbackOnSelect;
                if (arg.search) {
                    this.page.ctrls.taSearch.value = arg.search;
                    yield this.trySearch();
                }
                if (this._callbackOnSelect)
                    this.title = "Search and select profile:";
            }
            return _super.start.call(this);
        });
    }
    trySearch() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = this.page.ctrls.taSearch.value;
            if (!data)
                return;
            const users = yield this.lockgui(this.app.api.admin.profiles.searchUsers(data));
            if (!users)
                return;
            this.fill(users);
            this._urlArgs["search"] = decodeURI(data);
            this.updateUrl();
        });
    }
    fill(users) {
        this.page.ctrls.list.html = '';
        for (const user of users) {
            const item = new com.ListItem();
            item.ctrls.lType.text = "Profile";
            item.ctrls.lId.text = `#${user.id}`;
            let data = [gs.text.clearHtmlToText(`${user.name} ${user.surname}`)];
            for (const auth of user.auths)
                data.push(`${auth.authType}: ${gs.text.clearHtmlToText(auth.data)}`);
            item.ctrls.pData.html = data.join('<br>');
            this.page.ctrls.list.append(item);
            if (this._callbackOnSelect)
                item.onclick = () => this._callbackOnSelect(user);
            else
                item.onclick = () => gs_1.StateGS.Run(StateProfile_1.StateProfile, { "id": user.id.toString() });
        }
    }
}
exports.StateProfiles = StateProfiles;
StateProfiles.StateName = "profiles";
//# sourceMappingURL=StateProfiles.js.map